import {
  Home,
  ScanLine,
  GraduationCap,
  ClipboardCheck,
  Calendar,
  Video,
  CalendarDays,
  CalendarClock,
  ListTodo,
  ClipboardList,
  Users,
  Megaphone,
  Mail,
  FolderOpen,
  FileSpreadsheet,
  PenTool,
  Settings,
  Sparkles,
  BookOpen,
  Coffee,
  QrCode,
  Hourglass,
  PanelsTopLeft,
  Brain,
  Compass,
  Wallet,
  type LucideIcon,
} from "lucide-react";

export type SidebarMenuItemDefinition = {
  id: string;
  label: string;
  icon: LucideIcon;
  color: string;
  path: string;
  permission?: string | string[];
  yesToolsOnly?: boolean;
};

export const defaultMenuItems: SidebarMenuItemDefinition[] = [
  {
    id: "home",
    label: "Ana Sayfa",
    icon: Home,
    color: "#2563eb",
    path: "/dashboard",
  },
  {
    id: "announcements",
    label: "Duyurular",
    icon: Megaphone,
    color: "#ca8a04",
    path: "/announcements",
    permission: "announcement_list",
  },
  {
    id: "mail-marketing",
    label: "Mail Pazarlama",
    icon: Mail,
    color: "#0e7490",
    path: "/mail-marketing",
    permission: "mail_marketing_list",
  },
  {
    id: "surveys",
    label: "Anketler",
    icon: ClipboardCheck,
    color: "#dc2626",
    path: "/surveys",
    permission: "survey_list",
  },
  {
    id: "employees",
    label: "Üyeler",
    icon: Users,
    color: "#0f766e",
    path: "/employees",
    permission: "user_list",
  },
  {
    id: "meetings",
    label: "Toplantılar",
    icon: Video,
    color: "#7c3aed",
    path: "/meetings",
    permission: "meet_list",
  },
  {
    id: "calendar",
    label: "Takvim",
    icon: Calendar,
    color: "#c2410c",
    path: "/calendar",
    permission: "calendar_list",
  },
  {
    id: "navigator",
    label: "Koçum",
    icon: Compass,
    color: "#2563eb",
    path: "/navigator",
    permission: "navigator_view",
  },
  {
    id: "coach-observe",
    label: "Koç Gözlem",
    icon: Compass,
    color: "#4f46e5",
    path: "/coach-observe",
    permission: "navigator_observe",
  },
  {
    id: "tercih-leadleri",
    label: "Tercih Lead'leri",
    icon: Compass,
    color: "#2563eb",
    path: "/tercih-leadleri",
    permission: "tercih_lead_view",
  },
  {
    id: "lessons",
    label: "E-Eğitim",
    icon: GraduationCap,
    color: "#be185d",
    path: "/lessons",
    permission: "lesson_list",
  },
  {
    id: "ilmek",
    label: "İLMEK",
    icon: Brain,
    color: "#7c3aed",
    path: "/ilmek",
    permission: "ilmek_content_pack_list",
  },
  {
    id: "planning",
    label: "Planlama",
    icon: CalendarDays,
    color: "#15803d",
    path: "/planning",
    permission: "setting_update",
  },
  {
    id: "appointments",
    label: "Randevular",
    icon: CalendarClock,
    color: "#4d7c0f",
    path: "/appointments",
    permission: "appointment_list",
  },
  {
    id: "todos",
    label: "Yapılacaklar",
    icon: ListTodo,
    color: "#78350f",
    path: "/todos",
    permission: "todo_list",
  },
  {
    id: "tasks",
    label: "Görevler",
    icon: ClipboardList,
    color: "#475569",
    path: "/tasks",
    permission: "task_list",
  },
  {
    id: "files",
    label: "Dosyalar",
    icon: FolderOpen,
    color: "#0f172a",
    path: "/files",
    permission: "file_list",
  },
  {
    id: "practice-exams",
    label: "Denemeler",
    icon: FileSpreadsheet,
    color: "#0369a1",
    path: "/practice-exams",
    permission: ["practice_exam_list", "practice_exam_student_list"],
  },
  {
    // Kırtasiye: kendi okullarının optik dosyalarını kurum dışı LGS denemelerine yükler
    id: "kirtasiye-yukleme",
    label: "Deneme Yükleme",
    icon: ScanLine,
    color: "#b45309",
    path: "/kirtasiye-yukleme",
    permission: "external_exam_upload",
  },
  {
    id: "maarif-test-generator",
    label: "Test Oluşturma",
    icon: Sparkles,
    color: "#1d4ed8",
    path: "/maarif-test-generator",
    permission: "maarif_test_list",
  },
  {
    id: "maarif-question-wizard",
    label: "Maarif Soru Sihirbazı",
    icon: Sparkles,
    color: "#059669",
    path: "/maarif-question-wizard",
    permission: "maarif_question_list",
  },
  {
    id: "question-bank-indesign",
    label: "Dizgici",
    icon: FileSpreadsheet,
    color: "#0b7285",
    path: "/question-bank-indesign",
    permission: "question_bank_list",
  },
  {
    id: "social",
    label: "Sosyal Medya",
    icon: PanelsTopLeft,
    color: "#0f766e",
    path: "/social",
    permission: "social_list",
  },
  {
    id: "whiteboard",
    label: "Beyaz Tahta",
    icon: PenTool,
    color: "#059669",
    path: "/whiteboard",
    permission: "whiteboard_view",
  },
  {
    id: "speed-reading",
    label: "Hızlı Okuma",
    icon: BookOpen,
    color: "#0891b2",
    path: "/speed-reading",
    permission: "speed_reading_list",
  },
  {
    id: "cafe-menu",
    label: "Kafe",
    icon: Coffee,
    color: "#b45309",
    path: "/cafe-menu",
    yesToolsOnly: true,
  },
  {
    id: "akademi-qr",
    label: "Akademi QR",
    icon: QrCode,
    color: "#7c3aed",
    path: "/akademi-qr",
    yesToolsOnly: true,
  },
  {
    id: "time-center",
    label: "Zaman Merkezi",
    icon: Hourglass,
    color: "#2563eb",
    path: "/time-center",
    permission: "time_tracking_list",
  },
  {
    id: "payments",
    label: "Ödemeler",
    icon: Wallet,
    color: "#2563eb",
    path: "/payments",
    permission: "payment_orders_view",
  },
  {
    id: "settings",
    label: "Sistem Ayarları",
    icon: Settings,
    color: "#64748b",
    path: "/settings",
    permission: "setting_list",
  },
];
